module.exports = __webpack_public_path__ + "img/trip-fuel-coaching-2.57b927ec.svg";